import { render, staticRenderFns } from "./OrderConfirmationForm.vue?vue&type=template&id=c5778ed0"
import script from "./OrderConfirmationForm.vue?vue&type=script&lang=js"
export * from "./OrderConfirmationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports